import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { useAtom } from 'jotai/index';
import styles from './css/index.module.scss';
import Logo1 from '../../assets/icons/logo1.svg';
import Logo2 from '../../assets/icons/logo2.svg';
import ArrowUp from '../../assets/icons/arrowUp.svg';
import TgIcon from '../../assets/icons/tg.svg';
import { languageAtom } from '../../atoms/globalAtoms';
import useComponentVisible from '../../hooks/UseComponentVisible';
import LocalStorageServices from '../../services/LocalStorageServices';
import useTranslations from '../../hooks/useTranslations';
import { DICTIONARY } from '../../translations/dictionary';

function Header() {
  const { t } = useTranslations();
  const location = useLocation();
  const [language, setLanguage] = useAtom(languageAtom);
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible();

  const changeLang = (lang) => () => {
    setLanguage(lang);
    LocalStorageServices.setLanguage(lang);
  };

  const onContactClick = () => {
    window.open('https://t.me/auction_support_blockchain_bot', '_blank');
  };

  function MiddleDivUl() {
    return (
      <ul>
        <Link
          to="/"
          className={classNames(styles.link, { [styles.linkActive]: location.pathname === '/' || location.pathname.startsWith('/usernames') })}
        >
          {t(DICTIONARY.usernames)}
        </Link>
        <Link
          to="/numbers"
          className={classNames(styles.link, { [styles.linkActive]: location.pathname.startsWith('/numbers') })}
        >
          {t(DICTIONARY.numbers)}
        </Link>
        <Link
          to="/tutorials"
          className={classNames(styles.link, { [styles.linkActive]: location.pathname.startsWith('/tutorials') })}
        >
          {t(DICTIONARY.tutorials)}
        </Link>
        <Link
          to="/wallet-activate"
          className={classNames(styles.link, { [styles.linkActive]: location.pathname.startsWith('/wallet-activate') })}
        >
          {t(DICTIONARY.activateWallet)}
        </Link>
        <Link
          to="/username-activate"
          className={classNames(styles.link, { [styles.linkActive]: location.pathname.startsWith('/username-activate') })}
        >
          {t(DICTIONARY.activateUsername)}
        </Link>
      </ul>
    );
  }

  return (
    <div className={styles.header}>
      <a className={styles.logoDiv} href="/">
        <img src={Logo2} alt="" className={styles.iconOnly} />
        <img src={Logo1} alt="" />
      </a>
      <div className={styles.middleDiv}>
        <MiddleDivUl />
      </div>
      <div className={styles.rightDiv}>
        <div className={styles.languageSelect} onClick={() => setIsComponentVisible(!isComponentVisible)}>
          <span>{language.toUpperCase()}</span>
          <img className={classNames({ [styles.arrowUp]: isComponentVisible })} src={ArrowUp} alt="A" />

          {isComponentVisible && (
            <div ref={ref} className={classNames(styles.languageSelectFloat)}>
              <span onClick={changeLang('ru')}>RU</span>
              <span onClick={changeLang('en')}>EN</span>
            </div>
          )}
        </div>

        <div className={styles.contactUs} onClick={onContactClick}>
          <img src={TgIcon} alt=">" />
          <span>{t(DICTIONARY.contactUs)}</span>
        </div>
      </div>

      <div className={classNames(styles.middleDiv, styles.middleDivBottom)}>
        <MiddleDivUl />
      </div>
    </div>
  );
}

export default Header;
